var EnumObeStatus;
(function (EnumObeStatus) {
  EnumObeStatus["New"] = "New";
  EnumObeStatus["Active"] = "Active";
  EnumObeStatus["Inactive"] = "Inactive";
  EnumObeStatus["Shipped"] = "Shipped";
  EnumObeStatus["Frozen"] = "Frozen";
  EnumObeStatus["Lost"] = "Lost";
  EnumObeStatus["Terminated"] = "Terminated";
  EnumObeStatus["ApprovedAwaitingShipping"] = "ApprovedAwaitingShipping";
  EnumObeStatus["BeingReplaced"] = "BeingReplaced";
})(EnumObeStatus || (EnumObeStatus = {}));
export default EnumObeStatus;